module.exports = __webpack_public_path__ + "img/four1Blue.bc84c13f.jpg";